import { Box } from '@/components/box';
import { CountryFlag } from '@/components/country-flag';
import { Flex } from '@/components/flex';
import { Link } from '@/components/link';
import { PortTooltip } from '@/components/port-tooltip';
import { Text } from '@/components/text';
import { Tooltip } from '@/components/tooltip';
import { MODE_AIR } from '@/lib/constants';
import { LocationInterface, RouteLocationInterface } from '@/types';
import { SegmentModeType } from '@/types/api-types';
import { createPortPageUrl, getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

interface Props {
  port: Pick<RouteLocationInterface, 'identifiers' | 'countryCode' | 'name'>;
  mode: SegmentModeType;
  isDestination?: boolean;
  portDistance?: number;
  targetLocation?: LocationInterface;
  label?: string;
}

const PortCode = ({ port, mode, isDestination, portDistance, targetLocation, label = '' }: Props) => {
  const isAir = mode === MODE_AIR;
  const { identifiers, countryCode } = port;
  const identifier = getPreferredIdentifier(identifiers);
  const origText = isAir ? 'Departs from' : 'Port of loading';
  const destText = isAir ? 'Arrives at' : 'Port of discharge';
  const labelText = isDestination ? destText : origText;

  const { text } = styles();

  // Don't render a port code if there is no Preferred Identifier (i.e road)
  if (!identifier) return null;

  return (
    <Box>
      <Text variant="sm" className="m-0 text-grey-600">
        {label || labelText}
      </Text>
      <Flex alignItems="center">
        <CountryFlag countryCode={countryCode} />
        <Tooltip
          content={<PortTooltip location={port} mode={mode} distance={portDistance} targetLocation={targetLocation} />}
        >
          <Text className={text()}>
            <Link href={createPortPageUrl([identifier])} target="_blank">
              {identifier?.value}
            </Link>
          </Text>
        </Tooltip>
      </Flex>
    </Box>
  );
};

const styles = tv({
  slots: {
    text: 'm-0 ml-2 text-baseLg font-semibold [&_a]:border-b [&_a]:border-dashed [&_a]:border-grey-300 [&_a]:no-underline [&_a]:hover:border-b-text-primary',
  },
});

export { PortCode };
